export default __webpack_public_path__ + "static/media/badia.9b535175.png";